(() => {
  const root = document.querySelector('[data-ym-page]');
  if (!root || root.dataset.ymReady) return;
  root.dataset.ymReady = '1';
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const leafLayer = root.querySelector('[data-ym-scroll-leaves]');
  if (leafLayer && !leafLayer.dataset.ready && !reducedMotion.matches && Element.prototype.animate) {
    leafLayer.dataset.ready = '1';
    const leaves = [...leafLayer.querySelectorAll('.brio-scroll-leaf')];
    const zones = [...root.querySelectorAll('.ym-hero, .ym-plant, .ym-process, .ym-why, .ym-taste, .ym-origin, .ym-finale')];
    const active = new Map();
    const compact = () => innerWidth <= 700;
    const random = (min, max) => min + Math.random() * (max - min);
    const visibleZone = () => zones.find((zone) => {
      const rect = zone.getBoundingClientRect();
      return rect.top < innerHeight * .82 && rect.bottom > innerHeight * .18;
    });
    let previousZone = null;
    let previousY = scrollY;
    let travelled = 0;
    let lastSpawn = -Infinity;
    let frame = 0;

    const reset = () => {
      active.forEach((animation) => animation.cancel());
      active.clear();
      leaves.forEach((leaf) => {
        leaf.classList.remove('is-falling');
        leaf.removeAttribute('style');
      });
      previousZone = null;
      travelled = 0;
    };
    const launch = (zone) => {
      if (reducedMotion.matches || document.hidden || active.size >= (compact() ? 2 : 3)) return;
      const pool = compact() ? leaves.slice(0, 2) : leaves;
      const leaf = pool.find((item) => !active.has(item));
      if (!leaf) return;
      const mobile = compact();
      const lanes = mobile ? (zone.classList.contains('ym-hero') ? [86, 92] : [-3, 89]) : (zone.classList.contains('ym-hero') ? [67, 81, 93] : [-3, 5, 84, 94]);
      const x = lanes[Math.floor(Math.random() * lanes.length)];
      const size = mobile ? random(35, 51) : random(61, 104);
      const drift = random(mobile ? -25 : -72, mobile ? 25 : 72);
      const sway = random(mobile ? 7 : 16, mobile ? 17 : 39) * (Math.random() < .5 ? -1 : 1);
      const rotation = random(-38, 38);
      const turn = random(125, 265) * (Math.random() < .5 ? -1 : 1);
      const opacity = random(mobile ? .43 : .44, mobile ? .62 : .67);
      const blur = random(0, mobile ? 1.3 : 2.8);
      leaf.style.setProperty('--leaf-x', `${x}vw`);
      leaf.style.setProperty('--leaf-size', `${size}px`);
      leaf.classList.add('is-falling');
      const animation = leaf.animate([
        { transform: `translate3d(0,-18vh,0) rotate(${rotation}deg)`, opacity: 0, filter: `blur(${blur}px)` },
        { transform: `translate3d(${sway}px,4vh,0) rotate(${rotation + turn * .18}deg)`, opacity, offset: .16 },
        { transform: `translate3d(${drift * .45}px,48vh,0) rotate(${rotation + turn * .58}deg)`, opacity: opacity * .92, offset: .58 },
        { transform: `translate3d(${drift}px,112vh,0) rotate(${rotation + turn}deg)`, opacity: 0 }
      ], { duration: mobile ? random(5200, 6800) : random(6000, 8200), easing: 'cubic-bezier(.22,.45,.28,.98)', fill: 'forwards' });
      active.set(leaf, animation);
      const release = () => {
        if (active.get(leaf) !== animation) return;
        active.delete(leaf);
        leaf.classList.remove('is-falling');
        leaf.removeAttribute('style');
      };
      animation.onfinish = release;
      animation.oncancel = release;
    };
    const update = () => {
      frame = 0;
      if (reducedMotion.matches || document.hidden) {
        reset();
        previousY = scrollY;
        return;
      }
      const y = scrollY;
      travelled += Math.abs(y - previousY);
      previousY = y;
      const zone = visibleZone();
      if (!zone) {
        previousZone = null;
        travelled = 0;
        return;
      }
      const entering = zone !== previousZone;
      const now = performance.now();
      if ((entering || travelled >= (compact() ? 290 : 190)) && now - lastSpawn > (compact() ? 1450 : 950)) {
        launch(zone);
        lastSpawn = now;
        travelled = 0;
      }
      previousZone = zone;
    };
    const requestUpdate = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    document.addEventListener('visibilitychange', requestUpdate);
    reducedMotion.addEventListener?.('change', requestUpdate);
    window.addEventListener('pagehide', reset, { once: true });
    setTimeout(() => {
      if (visibleZone() !== zones[0] || reducedMotion.matches) return;
      launch(zones[0]);
      lastSpawn = performance.now();
      previousZone = zones[0];
      if (!compact()) setTimeout(() => { if (visibleZone() === zones[0]) launch(zones[0]); }, 650);
    }, 1150);
  }
  if (!window.gsap || !window.ScrollTrigger || reducedMotion.matches) return;
  const gsap = window.gsap;
  const ScrollTrigger = window.ScrollTrigger;
  gsap.registerPlugin(ScrollTrigger);
  const q = (selector) => root.querySelector(selector);
  const qa = (selector) => [...root.querySelectorAll(selector)];

  gsap.from(qa('.ym-hero__copy > *'), { y: 24, autoAlpha: 0, duration: .85, stagger: .11, delay: .1, ease: 'power2.out' });
  gsap.from(q('.ym-hero .ym-script'), { y: 24, autoAlpha: 0, duration: 1, delay: .6, ease: 'power2.out' });
  gsap.fromTo(q('.ym-hero .ym-bg'), { scale: 1.055 }, { scale: 1, ease: 'none', scrollTrigger: { trigger: q('.ym-hero'), start: 'top top', end: 'bottom top', scrub: true } });
  qa('[data-ym-reveal]').forEach((element) => gsap.from(element, { y: 40, autoAlpha: 0, duration: .9, ease: 'power2.out', scrollTrigger: { trigger: element, start: 'top 88%', once: true } }));
  gsap.fromTo(q('.ym-plant .ym-bg'), { yPercent: -4 }, { yPercent: 4, ease: 'none', scrollTrigger: { trigger: q('.ym-plant'), start: 'top bottom', end: 'bottom top', scrub: true } });
  if (matchMedia('(min-width: 761px)').matches) {
    [q('.ym-plant'), q('.ym-taste')].forEach((panel) => gsap.fromTo(panel, { y: 45 }, { y: 0, ease: 'none', scrollTrigger: { trigger: panel, start: 'top 95%', end: 'top 60%', scrub: true } }));
  }
  gsap.fromTo(q('.ym-why__product img'), { y: 75, scale: .9 }, { y: 0, scale: 1, ease: 'none', scrollTrigger: { trigger: q('.ym-why'), start: 'top 85%', end: 'center 48%', scrub: .6 } });
  gsap.from(qa('[data-ym-flavour]'), { y: 85, autoAlpha: 0, duration: .9, stagger: .13, ease: 'power2.out', scrollTrigger: { trigger: q('.ym-taste__flavours'), start: 'top 88%', once: true } });
  gsap.fromTo(q('.ym-origin__photo img'), { scale: 1.1 }, { scale: 1, ease: 'none', scrollTrigger: { trigger: q('.ym-origin'), start: 'top bottom', end: 'bottom top', scrub: true } });

  const finaleCans = qa('.ym-finale__cans img');
  gsap.set(finaleCans, { y: 115, autoAlpha: 0 });
  gsap.set(q('.ym-finale__actions'), { y: 18, autoAlpha: 0 });
  gsap.timeline({ scrollTrigger: { trigger: q('.ym-finale'), start: 'top 80%', end: 'center 50%', scrub: .65 } })
    .to(finaleCans, { y: 0, autoAlpha: 1, stagger: .16, duration: .65, ease: 'none' })
    .to(q('.ym-finale__actions'), { y: 0, autoAlpha: 1, duration: .35, ease: 'none' }, '>-0.08');

  const stages = qa('[data-ym-stage]');
  const track = q('.ym-process__track span');
  ScrollTrigger.matchMedia({
    '(min-width: 761px)': () => {
      gsap.set(stages, { opacity: .38, y: 14, scale: .96 });
      gsap.set(stages[0], { opacity: 1, y: 0, scale: 1 });
      const timeline = gsap.timeline({
        defaults: { ease: 'none' },
        scrollTrigger: { trigger: q('.ym-process'), start: 'top top', end: () => '+=' + Math.round(innerHeight * 2.1), pin: true, pinSpacing: true, scrub: .6, anticipatePin: 1, invalidateOnRefresh: true }
      });
      timeline.to({}, { duration: .6 });
      for (let index = 1; index < stages.length; index++) {
        timeline.to(stages[index - 1], { opacity: .55, scale: .97, duration: .25 })
          .to(stages[index], { opacity: 1, y: 0, scale: 1, duration: .5 }, '<')
          .to(track, { scaleX: index / (stages.length - 1), duration: .5 }, '<')
          .to({}, { duration: .28 });
      }
      timeline.to({}, { duration: .7 });
    },
    '(max-width: 760px)': () => {
      gsap.fromTo(track, { scaleY: 0 }, { scaleY: 1, ease: 'none', scrollTrigger: { trigger: q('.ym-process'), start: 'top 80%', end: 'bottom 80%', scrub: true } });
      stages.forEach((stage) => gsap.from(stage, { x: 25, autoAlpha: 0, duration: .6, ease: 'power2.out', scrollTrigger: { trigger: stage, start: 'top 90%', once: true } }));
    }
  });
  window.addEventListener('load', () => ScrollTrigger.refresh(), { once: true });
})();
